$(".show-modal").click(function() {
  var address_id = $(this).attr('data-address-id')
  $('#delete-address').attr('href', `/user/addresses/${address_id}`)
  $('#delete-address').attr('data-method', `delete`)
})

$('.destroy-history').click(function() {
  var activity_id = $(this).attr('data-activity-id')

  if (activity_id == 'clear-all') {
    var datas = { 'destroy_all': true }
    $(this).closest('.search-action').remove()
  } else {
    var datas = { 'activity_id': activity_id }
    $(this).parent().remove()
  }

  var deleteUrl = $(this).attr('data-delete-url')
  $.ajax({
    url: deleteUrl,
    method: 'DELETE',
    contenType: 'application/json',
    data: datas,
    dataType: 'script'
  });
})
